<script>
export default {
  title: 'Assignment 2: Remote Process Execution',
  starterId: null
}
</script>

<template>
  <section>

    <Readings :readings="[
      {
        title: '<cite>Your UNIX/LINUX: The Ultimate Guide (3rd Edition)</cite> Section 13.12'
      },
      {
        title: '<cite>Your UNIX/LINUX: The Ultimate Guide (3rd Edition)</cite> Sections 11.1 - 11.9'
      }
    ]"/>

    <article>
      <h2>Overview</h2>
      <p>This assignment will give you an introduction to networking, SSH, and
        how to do remote process execution.</p>
    </article>

    <article>
      <h2>Part 1: Create SSH Key</h2>
      <p>Create a single passphrase protected ssh key for both accounts, and
        setup your accounts to allow logins based on this key.</p>
    </article>

    <article>
      <h2>Part 2: SSH Agent</h2>
      <p>You can use <code>ssh-agent</code> to store your keys after they have
        been decrypted with your passphrase. This way, you can enter your
        passphrase once (when you execute <code>ssh-add</code>) rather than every
        time you make a connection with <code>ssh</code>.  Setup
        <code>ssh-agent</code>, add your key to the agent, and connect to your
        other account using without needing to enter a passphrase or password. Save
        this session to a transcript which you will show your tutor for a checkoff.
        (Note/Clarification: You will need to enter your passphrase when you add
        your key to the agent, but you don't enter the passphrase when connecting
        to the other account.)</p>
    </article>

    <article>
      <h2>Part 3: Remote Process Execution</h2>
      <p>Using a bash for loop, ssh, and other common unix commands, create an
        <code>alias</code> that lists all users logged on to any of the following
        servers: cory and ashby. You should not need to enter a password
        (hint, finish part 2 fist), and your list should be sorted with no repeated
        entries. For checkoff, bring in a transcript which shows the alias
        definition and usage.</p>
    </article>

    <article>
      <h2>Part 4: Version Control</h2>

      <p><a href="http://svnbook.red-bean.com" target="_blank">Version Control with Subversion</a></p>

      <p>To do this assignment, first you must create a repository. To create a
        repository, type:</p>

      <pre v-highlightjs><code class="bash">$ svnadmin create /path/to/repository</code></pre>

      <p>You should not directly edit any of the files in the repository
        folder.</p>

      <p>Next, you will need to "check out" a copy of the repository in a new
        folder:</p>

      <pre v-highlightjs><code class="bash">$ svn checkout file:///full/path/to/repository newfolder</code></pre>

      <p>Use 'script' to record the following commands and their output so that
        you can show them to a tutor:</p>

      <ol>
        <li>Create a new empty file, test.txt, and add it to the repository.</li>
        <li>Add some text to the file, and commit the change to the repository.</li>
        <li>Check out a second copy of the repository in a second new folder. Using these two copies of the text file <u>in your local folders</u>, create a conflict in test.txt, and then resolve the conflict.</li>
        <li>Create another file, commit it to the repository, and then delete it from the repository. Do not use "rm".</li>
      </ol>
    </article>

    <article>
      <h2>Checklist</h2>

      <article>
        <h3>Part 1</h3>
        <ul>
          <li>Student can demonstrate logging in to both accounts using their ssh key (not password).</li>
        </ul>
      </article>

      <article>
        <h3>Part 2</h3>
        <ul>
          <li>Student's transcript shows correct usage of ssh-agent and ssh-add.</li>
        </ul>
      </article>

      <article>
        <h3>Part 3</h3>
        <ul>
          <li>Student's transcript shows correct alias definition and usage.</li>
        </ul>
      </article>

      <article>
        <h3>Part 4</h3>
        <ul>
          <li>Student's transcript shows correct usage of Subversion.</li>
        </ul>
      </article>
    </article>
  </section>
</template>



// WEBPACK FOOTER //
// src/components/assignments/unix/RemoteProcessExecution.vue